import {
  BarsLoader,
  BarsLoaderProps,
} from '@insight-health-ai/roseate/components';
import classNames from 'classnames';

type ScreenLoaderProps = {
  className?: string;
  loaderText?: string;
  loaderProps?: BarsLoaderProps;
};

export const ScreenLoader = ({
  className,
  loaderText,
  loaderProps,
}: ScreenLoaderProps) => {
  return (
    <div
      className={classNames(
        'flex h-full w-full flex-col gap-4 overflow-hidden items-center justify-center',
        className
      )}
    >
      <BarsLoader {...loaderProps} />
      <span className="text-gray-500 max-w-[320px] text-center">
        {loaderText}
      </span>
    </div>
  );
};
